const  commonLangCN = {
    more:"更多",
    moreGoods:"更多商品",
    noMore:"没有更多了",
    homePage:"首页",
    classification:"分类",
    shopping:"购物",
    mine:"我的",
    loading:"加载中...",
    failLoad:"加载失败！",
    title:"啊购购商城",
    fail:"失败",
    home:"首页",
    categories:"分类",
    purchase:"购物",
    me:"我的",
    waitForPayment:"等待付款",
    waitForSend:"等待发货",
    delivered:"已发货",
    completed:"已完成",
    canceled:"已取消",
    invalidOrders:"无效订单",
    confirm:"确认",
    cancel:"取消",
    relatedProducts:"相关商品",
    refreshSuccess:"刷新成功",
}

const  commonLangEN = {
    more:"More",
    moreGoods:"More Goods",
    noMore:"No More",
    homePage:"Index",
    classification:"Classify",
    shopping:"Shopping",
    mine:"Mine",
    loading:"Loading...",
    failLoad:"fail to load！",
    title:"I gogo Mall",
    fail:"failed!",
    //底部导航栏
    home:"Home",
    categories: "Categories",
    purchase:"Purchase",
    me:"Me",
    waitForPayment:"Wait for payment",
    waitForSend:"Wait for send",
    delivered:"Delivered",
    completed:"Completed",
    canceled:"Canceled",
    invalidOrders:"Invalid orders",
    confirm:"Confirm",
    cancel:"Cancel",
    relatedProducts:"Related products",
    refreshSuccess:"Refresh the success",
}

const commonLangPackage = {
    cn:commonLangCN,
    en:commonLangEN
}


export { commonLangPackage }
